import { useSelector } from 'react-redux';
import { findMatch } from '@/utils/resultsHelper';
import { eventSubscriptions } from '../constants';

const basicSubscriptionState = (items) => {
  const event = eventSubscriptions.USERS_REGISTERED;
  return { event, isSubscribed: !!findMatch(items, event, 'event') };
};

const useSubscriberConfirmationDialog = () => {
  const { subscriptions: { results, saveStatus } } = useSelector(({ notifications }) => notifications);
  return { ...basicSubscriptionState(results), saveStatus };
};

const useSubscribeUserRegisteredAction = () => {
  const { subscriptions: { readStatus, results } } = useSelector(({ notifications }) => notifications);
  return { isSubscribed: basicSubscriptionState(results).isSubscribed, readStatus };
};

export default {
  useSubscriberConfirmationDialog,
  useSubscribeUserRegisteredAction,
};
